import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import IBackupRestoreSetting from "../../models/settings/BackupRestoreSettings";
import {
  Input,
  Button,
  ToggleSwitch,
  Dropdown,
  DropdownOption,
  Checkbox,
} from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import { ABB_VIEW, ABB_HIDE } from "../../utilities/IconConstants";
import { tree } from "d3-hierarchy";
import FileExportSetting from "./FileExportSetting"

interface IProps {
  settingsXML: IBackupRestoreSetting;
  setIsNetworkSharedXML: (value: string) => void;
  setDomainXML: (value: string) => void;
  setUserNameXML: (value: string) => void;
  setPasswordXML: (value: string) => void;
  setLocationXML: (value: string) => void;
  setIpAddressXML: (value: string) => void;
  setPortXML: (value: string) => void;
  testBackupFolderConnectionXML: () => void;
  setAutoGenerateXML: (value: number) => void;

  msettingsXML: IBackupRestoreSetting;
  msetIsNetworkSharedXML: (value: string) => void;
  msetDomainXML: (value: string) => void;
  msetUserNameXML: (value: string) => void;
  msetPasswordXML: (value: string) => void;
  msetLocationXML: (value: string) => void;
  msetIpAddressXML: (value: string) => void;
  msetPortXML: (value: string) => void;
  mtestBackupFolderConnectionXML: () => void;
  msetAutoGenerateXML: (value: number) => void;

  msettingsXLS: IBackupRestoreSetting;
  msetIsNetworkSharedXLS: (value: string) => void;
  msetDomainXLS: (value: string) => void;
  msetUserNameXLS: (value: string) => void;
  msetPasswordXLS: (value: string) => void;
  msetLocationXLS: (value: string) => void;
  msetIpAddressXLS: (value: string) => void;
  msetPortXLS: (value: string) => void;
  mtestBackupFolderConnectionXLS: () => void;
  msetAutoGenerateXLS: (value: number) => void;

  msettingsAL1: IBackupRestoreSetting;
  msetIsNetworkSharedAL1: (value: string) => void;
  msetDomainAL1: (value: string) => void;
  msetUserNameAL1: (value: string) => void;
  msetPasswordAL1: (value: string) => void;
  msetLocationAL1: (value: string) => void;
  msetIpAddressAL1: (value: string) => void;
  msetPortAL1: (value: string) => void;
  mtestBackupFolderConnectionAL1: () => void;
  msetAutoGenerateAL1: (value: number) => void;
  enableDisableContent: (value:boolean,type:number) =>void;
  ipErrorSample: boolean;
  ipErrorXML: boolean;
  ipErrorXLS: boolean;
  ipErrorAL1: boolean;
  portErrorSample: boolean;
  portErrorXML: boolean;
  portErrorXLS: boolean;
  portErrorAL1: boolean;
}
interface AppState {
  isRevelPassword: boolean;
  isRevelMPassword: boolean;
  isRevelMXLSPassword: boolean;
}

export default class BackupSampleXML extends React.Component<IProps, AppState> {
  private _mount: boolean = false;
  private _settingsData: any;
  private fileRef: any = React.createRef<HTMLDivElement>();
  private locationRef: any = React.createRef<HTMLDivElement>();
  private drives: any[] = [
    { value: "Z", label: "Z:" },
    { value: "Y", label: "Y:" },
    { value: "X", label: "X:" },
    { value: "W", label: "W:" },
    { value: "V", label: "V:" },
    { value: "U", label: "U:" },
    { value: "T", label: "T:" },
    { value: "S", label: "S:" },
    { value: "R", label: "R:" },
    { value: "Q", label: "Q:" },
    { value: "P", label: "P:" },
    { value: "O", label: "O:" },
    { value: "N", label: "N:" },
    { value: "M", label: "M:" },
    { value: "L", label: "L:" },
    { value: "K", label: "K:" },
    { value: "J", label: "J:" },
    { value: "I", label: "I:" },
    { value: "H", label: "H:" },
    { value: "G", label: "G:" },
    { value: "F", label: "F:" },
    { value: "E", label: "E:" },
    { value: "D", label: "D:" },
    { value: "B", label: "B:" },
    { value: "A", label: "A:" },
  ];

  constructor(props: IProps) {
    super(props);
    this._mount = true;
    this.state = {
      isRevelPassword: false,
      isRevelMPassword: false,
      isRevelMXLSPassword: false,
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    if (this.locationRef.current !== null) {
      this.locationRef.current.setAttribute("directory", "");
      this.locationRef.current.setAttribute("webkitdirectory", "");
    }
  }

  

  private toggleMPassword = () => {
    this.setState({
      isRevelMPassword: !this.state.isRevelMPassword,
    });
  };

  private toggleMXLSPassword = () => {
    this.setState({
      isRevelMXLSPassword: !this.state.isRevelMXLSPassword,
    });
  };

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            <div className="row no-margin no-padding">
              <FileExportSetting 
                settings={this.props.settingsXML}
                setIsNetworkShared={(value) => this.props.setIsNetworkSharedXML(value)}
                setDomain={(value) => this.props.setDomainXML(value)}
                setUserName={(value) => this.props.setUserNameXML(value)}
                setPassword={(value) => this.props.setPasswordXML(value)}
                setLocation={(value) => this.props.setLocationXML(value)}
                setIpAddress={(value) => this.props.setIpAddressXML(value)}
                setPort={(value) => this.props.setPortXML(value)}
                testBackupFolderConnection={() =>
                  this.props.testBackupFolderConnectionXML()
                }
                setAutoGenerate={(value) => this.props.setAutoGenerateXML(value)}
                enableDisableContent={this.props.enableDisableContent}
                headingText={t(CONSTANTS.MENU_SAMPLE_XML)}
                enableDisableContentCount={1}
                ipError={this.props.ipErrorSample}
                portError={this.props.portErrorSample}
                showAutoGenerateToggle={false}
              ></FileExportSetting>
              <FileExportSetting 
                settings={this.props.msettingsXML}
                setIsNetworkShared={(value) => this.props.msetIsNetworkSharedXML(value)}
                setDomain={(value) => this.props.msetDomainXML(value)}
                setUserName={(value) => this.props.msetUserNameXML(value)}
                setPassword={(value) => this.props.msetPasswordXML(value)}
                setLocation={(value) => this.props.msetLocationXML(value)}
                setIpAddress={(value) => this.props.msetIpAddressXML(value)}
                setPort={(value) => this.props.msetPortXML(value)}
                testBackupFolderConnection={() =>
                  this.props.mtestBackupFolderConnectionXML()
                }
                setAutoGenerate={(value) => this.props.msetAutoGenerateXML(value)}
                enableDisableContent={this.props.enableDisableContent}
                headingText={t(CONSTANTS.MENU_MEASUREMENT_XML)}
                enableDisableContentCount={2}
                ipError={this.props.ipErrorXML}
                portError={this.props.portErrorXML}
                showAutoGenerateToggle={true}
              ></FileExportSetting>
              <FileExportSetting 
                settings={this.props.msettingsXLS}
                setIsNetworkShared={(value) => this.props.msetIsNetworkSharedXLS(value)}
                setDomain={(value) => this.props.msetDomainXLS(value)}
                setUserName={(value) => this.props.msetUserNameXLS(value)}
                setPassword={(value) => this.props.msetPasswordXLS(value)}
                setLocation={(value) => this.props.msetLocationXLS(value)}
                setIpAddress={(value) => this.props.msetIpAddressXLS(value)}
                setPort={(value) => this.props.msetPortXLS(value)}
                testBackupFolderConnection={() =>
                  this.props.mtestBackupFolderConnectionXLS()
                }
                setAutoGenerate={(value) => this.props.msetAutoGenerateXLS(value)}
                enableDisableContent={this.props.enableDisableContent}
                headingText={t(CONSTANTS.MENU_MEASUREMENT_XLS)}
                enableDisableContentCount={3}
                ipError={this.props.ipErrorXLS}
                portError={this.props.portErrorXLS}
                showAutoGenerateToggle={true}
              ></FileExportSetting>
              <FileExportSetting 
                settings={this.props.msettingsAL1}
                setIsNetworkShared={(value) => this.props.msetIsNetworkSharedAL1(value)}
                setDomain={(value) => this.props.msetDomainAL1(value)}
                setUserName={(value) => this.props.msetUserNameAL1(value)}
                setPassword={(value) => this.props.msetPasswordAL1(value)}
                setLocation={(value) => this.props.msetLocationAL1(value)}
                setIpAddress={(value) => this.props.msetIpAddressAL1(value)}
                setPort={(value) => this.props.msetPortAL1(value)}
                testBackupFolderConnection={() =>
                  this.props.mtestBackupFolderConnectionAL1()
                }
                setAutoGenerate={(value) => this.props.msetAutoGenerateAL1(value)}
                enableDisableContent={this.props.enableDisableContent}
                headingText={t(CONSTANTS.SAMPLE_AL1)}
                enableDisableContentCount={4}
                ipError={this.props.ipErrorAL1}
                portError={this.props.portErrorAL1}
                showAutoGenerateToggle={true}
              ></FileExportSetting>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
